import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px 24px 28px;

  .close-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
    background: none;
    border: none;
    color: #333;
    font-size: 0.9rem;
    cursor: pointer;
    padding: 0 0 12px;
  }

  .close-btn .material-icons {
    font-size: 18px;
  }

  .modal-grid {
    display: flex;
    gap: 28px;
  }

  .col-left {
    flex: 1;
    min-width: 0;
  }

  .col-left .thumb {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    border-radius: 8px;
    overflow: hidden;
    background: #0d1b2a center/cover no-repeat;
  }

  .col-left .thumb img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .col-left .live-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1f2430;
    margin: 14px 0 4px;
  }

  .col-left .live-date {
    font-size: 0.85rem;
    color: #6b7280;
  }

  .divider {
    width: 1px;
    background: #ced4da;
  }

  .col-right {
    flex: 1;
    min-width: 0;
  }

  .col-right h3 {
    font-size: 1.15rem;
    font-weight: 700;
    color: #1f2430;
    margin-bottom: 18px;
  }

  .form-group {
    margin-bottom: 14px;
  }

  .form-group label {
    font-size: 0.9rem;
    font-weight: 600;
    color: #1f2430;
    margin-bottom: 4px;
  }

  .form-group .form-control {
    height: 38px;
    border-radius: 8px;
  }

  .error {
    color: #dc3545;
    font-size: 0.85rem;
    margin-bottom: 10px;
  }

  @media (max-width: 640px) {
    .modal-grid {
      flex-direction: column;
    }

    .divider {
      display: none;
    }
  }
`;
